/* eslint-disable */
import clsx from "clsx";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import {
  CloseIcon,
  Documents,
  DropdownIcon,
  LeftArrowIcon,
  LockIcon,
  ReloadIcon,
  VisibilityOnIcon,
} from "../../assets/Icons";
import Button from "../../components/ui/Button";
import TextField from "../../components/ui/TextField";
import Typograpy from "../../components/ui/Typography";
import { getAdditionalDox, getTransactionSummary } from "../../services/remittance";
import {
  additionalData,
  recipientDetails,
  selectVendor,
  transactionDetails,
  triggerTransactionSummary,
  userAdditionalDocs,
  vendorCodes,
} from "../../store";
import { getPurposeCode } from "../../utils";
import { customAlert } from "../../utils/CustomAlert";
import { Calculation } from "./Calculation";
import { Modals } from "./Modals";
import { getDocumentList } from "../../services/userDocuments";
import AdditionalDocumentsList from "../../components/ui/DocUpload";
import { uploadAdditionalDocs } from "../../services/kyc";
import mixpanel from "mixpanel-browser";

export const PurposeCodePage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState<string>("start");
  const [taxStep, setTaxStep] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [transactionData, setTransactionData] = useRecoilState(transactionDetails);
  const [recipientData] = useRecoilValue(recipientDetails);
  const [purposeCode, setPurposeCode] = useState<string>(transactionData.purposeCode);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [additionalDocData, setAdditionalDocData] = useRecoilState(additionalData);
  const [additionalDocUploaded, setAdditionalDocUploaded] = useRecoilState(userAdditionalDocs);

  const [listOfDocuments, setListOfDocuments] = React.useState<any>();
  const [preViewImage, setPreViewImage] = React.useState("");
  const apiCall = useRecoilValue(triggerTransactionSummary);

  const proceedClass =
    "w-[190px] mt-10 py-3 rounded text-white bg-primary-1050 hover:scale-101 font-semibold";
  const [purposeValue, setPurposeValue] = useState<string>(transactionData.transaction_purpose);
  const [initialFunctionCall, setInitialFunctionCall] = useState(false);
  const loan = localStorage.getItem("isEducation") || "";
  const tcs = transactionData?.tcs;
  const noDocs = purposeCode === "S1108" || purposeCode === "S1107" || purposeCode === "S0306";
  const [preViewImageSrc, setPreViewImageSrc] = React.useState({
    fileName: "",
    uploadedFile: "",
  });
  const resetAdditionalDocData = useResetRecoilState(additionalData);
  const selectedPurposeValue =
    (transactionData?.transaction_purpose &&
      transactionData?.transaction_purpose.replace(/\s+/g, "-")) ||
    "";

  const [customLoader, setCustomLoader] = React.useState({
    aadhaarOtpLoader: false,
    panLoader: false,
    aadhaarBackLoader: false,
    voterCardLoader: false,
    drivingLoader: false,
    passportBackLoader: false,
    passportFrontLoader: false,
    "Student-Passport": false,
    "Student-Passport Back": false,
    "University-Offer-Letter": false,
    "Rent-Agreement-Invoice": false,
    "Relationship-Proof": false,
    "Beneficiary-ID": false,
    "Recipient-passport-Driving-license-SSN-number": false,
    "Gift-Declaration": false,
    "Air-Ticket-Copy": false,
    Visa: false,
    "Loan-Sanction-letter": false,
  });

  useEffect(() => {
    resetAdditionalDocData();
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      sessionStorage.setItem("navigatingFromPage", "true");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (initialFunctionCall) {
      getAdditionalDocs();
    }
  }, [initialFunctionCall]);

  useEffect(() => {
    setTimeout(() => {
      const shouldNavigate = sessionStorage.getItem("navigatingFromPage") === "true";
      if (shouldNavigate) {
        sessionStorage.removeItem("navigatingFromPage");
        navigate("/remittance", { replace: true });
      }
    }, 500);
  }, [navigate]);

  const handleProceed = () => {
    navigate("/review");
  };

  const isProceed = useMemo(() => {
    let proceed =
      additionalDocData.length > 0 &&
      additionalDocData?.every((item) => (item.isMandatory ? item.isUploaded : true));
    return proceed;
  }, [listOfDocuments, additionalDocData]);


  const vendorCode = useRecoilValue(selectVendor);


  const truncatedText = (originalText: string) => {
    const maxLength = 10;
    return originalText.slice(0, maxLength) + "..." + originalText.slice(-7);
  };

  const idToken = localStorage.getItem("userToken") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const isEducation: any = localStorage.getItem("isEducation");
  const userId = localStorage.getItem("vendorUserKey") || "";

  const onChangeHandlerType = localStorage.getItem("onChangeHandler") || "send";

  useEffect(() => {
        const body = {
      ...(onChangeHandlerType === "send"
        ? { user_send: transactionData?.user_send ?? 0 }
        : { reciepient_recieve: transactionData?.reciepient_recieve ?? 0 }),
      }
    getTransactionSummary(
      {
        ...body,
        transVendorKey: vendorCode?.userId,
        purposeCode: purposeCode,
        transaction_purpose: purposeValue,
        base_currency: transactionData.base_currency,
        conversion_rate: transactionData.conversion_rate,
        dest_currency: transactionData.dest_currency,
        hop_coins: 0,
        isEducation: isEducation === "true" ? true : false,
        vendor_key: currentUser.vendor_key,
        userId: userId,
        isBene: transactionData.isBene === null ? false : transactionData.isBene,
      },
      idToken,
    )
      .then((response) => {
        setTransactionData((prev) => ({
          ...prev,
          ...response?.data,
          transactionLeadIds: {
            ...(prev.transactionLeadIds || {}),
            // ...(response?.data?.transactionLeadIds || {}),
          }
        }));
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
      getDocuments()
      if (noDocs) {
        navigate("/pick-recipient");
      }
  }, [purposeCode]);

  const getAdditionalDocs = () => {
  getAdditionalDox(purposeCode)
    .then((res) => {
      const updatedList: any = [...(listOfDocuments || [])];
      const transactionLeadIdsObject: any = {};

      res?.data?.leadDocList?.forEach((item: any) => {
        // Normalize docName
        let newName = item?.docName?.trim().replace(/[\s\-_]+/g, "_");

        // Special handling for known edge cases
        if (newName === "Student_Passport") {
          newName = "Student_Passport_Front";
        } else if (newName === "Student_Passport_Back") {
          newName = "Student_Passport_Back";
        }

        const availableCodes = updatedList.map((doc: any) => doc.code);

        const existingDocIndex = updatedList.findIndex((doc: any) => doc.code === newName);

        if (existingDocIndex !== -1) {
          const isMandatory =
            additionalDocData?.some(
              (docData: any) => docData.code === newName && docData.isMandatory
            ) || false;

          updatedList[existingDocIndex] = {
            ...updatedList[existingDocIndex],
            isUploaded: true,
            uploadedId: item?.id,
            fileName: item?.docName,
            uploadedFile: item?.docUrl,
            isMandatory: isMandatory,
          };

          transactionLeadIdsObject[newName] = item?.id;
        } else {
          console.warn(`No matching doc.code found in UI state for: ${newName}`);
        }
      });

      setListOfDocuments(updatedList);
      setAdditionalDocData(updatedList);
      setTransactionData((prev) => ({
        ...prev,
        transactionLeadIds: {
          // ...(prev.transactionLeadIds || {}),
          ...transactionLeadIdsObject,
        },
      }));
    })
    .catch((err) => {
      console.error("Error fetching additional docs:", err);
    });
};

  const handleAdditionalDocUpload = (
    e: { target: { files: any[] } },
    code: string,
    purpose: string,
    id: number,
  ) => {
    const fileData = e.target.files[0];
    let data = new FormData();
    data.append("file", fileData);
    uploadAdditionalDocs({ body: data, code: code, purpose: purpose })
      .then((response) => {
        if (code.replace(/_/g, "-") === "Student-Passport-Front") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            studentPassport: true,
          });
        } else if (code.replace(/_/g, "-") === "Student Passport Back") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            studentPassportBack: true,
          });
        } else if (code.replace(/_/g, "-") === "University-Offer-Letter") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            offerLetter: true,
          });
        } else if (code.replace(/_/g, "-") === "Rent-Agreement-Invoice") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            rentNotice: true,
          });
        } else if (code.replace(/_/g, "-") === "Relationship-Proof") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            relationProof: true,
          });
        } else if (code.replace(/_/g, "-") === "Beneficiary-ID") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            beneficiaryId: true,
          });
        } else if (code.replace(/_/g, "-") === "Recipient-passport-Driving-license-SSN-number") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            recipientPassDLssn: true,
          });
        } else if (code.replace(/_/g, "-") === "Gift-Declaration") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            giftDeclaration: true,
          });
        } else if (code.replace(/_/g, "-") === "Air-Ticket-Copy") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            airTicket: true,
          });
        } else if (code.replace(/_/g, "-") === "Visa") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            visa: true,
          });
        } else if (code.replace(/_/g, "-") === "Loan-Sanction-letter") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            loanLetter: true,
          });
        }
        setTransactionData((prev) => ({
          ...prev,
          transactionLeadIds: {
            ...(prev.transactionLeadIds || {}),
            [code]: response?.data?.leadDocId,
          },
        }));
        const uploadedData = listOfDocuments.filter((data: any) => {
          return data.code === code;
        })[0];

        const updatedData = {
          ...uploadedData,
          isUploaded: true,
          fileName: fileData.name,
          uploadedId: response?.data?.leadDocId,
          uploadedFile: URL.createObjectURL(e.target.files[0]),
        };

        const updatedList = listOfDocuments.map((doc: any) => {
          if (doc.id === updatedData.id) {
            return { ...updatedData };
          }
          return doc;
        });

        setListOfDocuments(updatedList);
        setAdditionalDocData(updatedList);
      })
      .catch((error) => {
        console.error("ERROR", error);
      });
  };

  const preViewModalHeader = (
    <div className="flex items-center justify-start">
      <div
        className="flex items-center justify-between mr-4 lg:hidden"
        onClick={() => setIsModalOpen("")}
      >
        <LeftArrowIcon />
      </div>
      <div className="items-center justify-between hidden mr-10 lg:flex">
        <Button
          bgColor="bg-primary-450"
          fontStyle={{
            fontFamily: "",
            fontSize: "text-sm",
            fontWeight: "font-medium",
            fontColor: "text-primary",
          }}
          borderStyle={{
            borderRadius: "rounded",
          }}
          className="py-2 px-[18px]"
          onClickHandler={() => setIsModalOpen("")}
        >
          {"<< Go Back"}
        </Button>
      </div>
      <Typograpy
        tagType="div"
        text="Document Preview"
        className="text-black font-normal font-lato text-[32px] mr-[26px] hidden lg:flex"
      />
      <Typograpy
        tagType="div"
        text={preViewImageSrc?.fileName}
        className="text-2xl font-normal text-primary-400 font-lato"
      />
    </div>
  );

  const getDocuments = () => {
    getDocumentList(
      transactionData?.transaction_purpose,
      transactionData?.dest_currency,
      recipientData?.type,
    )
      .then((data: any) => {
        let count = -1;
        const neededDocs = data.map((item: any) => {
          count++;
          return {
            id: count,
            name: item.document,
            code: item.document.replace(/\s+/g, "_"),
            isUploaded: false,
            uploadedId: 0,
            fileName: "",
            isMandatory: item.isRequired,
            // item?.document === "Loan Disbursement Letter"
            //   ? transactionDetailsData?.isEducation
            //     ? true
            //     : item.isRequired
            //   : item.isRequired,
            uploadedFile: "",
            errorMessage: "",
          };
        });
        setAdditionalDocData(neededDocs);
        setListOfDocuments(neededDocs);
        setInitialFunctionCall(true);
      })
      .catch((error) => {
        console.error("ERROR", error);
      });
  };

  const handleAdditionalDocRemove = (index: number, docType: string, code: any) => {
    const updatedListOfDocs = listOfDocuments.map((file: any) => {
      return file.id === index
        ? { ...file, isUploaded: false, uploadedFile: "", fileName: "" }
        : file;
    });
    setListOfDocuments(updatedListOfDocs);
    setAdditionalDocData(updatedListOfDocs);
  };

  return (
    <div>
      <div className="flex flex-col">
        <div
          id="header"
          // style={{ width: "calc(95vw - 105px)" }}
          className="flex items-center justify-center px-10 py-12 mt-10"
        >
          <div
            onClick={() => {
              setStep("start");
            }}
            className="flex flex-col items-center"
          >

            <span className="text-[30px] font-semibold font-ssp">Recipient Documents</span>
            <span className="text-[20px] font-ssp">
              Please upload the required documents for recipient.

            </span>
          </div>
          {/* <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon fill="black" />
          </div> */}
        </div>
        <div id="body" className="flex justify-center h-screen">
          <div id="left" className="flex flex-col items-center w-1/2">
            {step === "start" && (
              <>
                <div
                  id="purpose"
                  // onClick={() => {
                  //   setIsModalOpen("purpose");
                  // }}
                  className="h-12 mt-10 w-3/5 border border-black flex items-center rounded-md p-4 bg-gray-300 text-[14px] justify-between cursor-not-allowed"
                >
                  <div>{purposeValue ? purposeValue : "Select Purpose of Payment"}</div>
                  <div>
                    <DropdownIcon />
                  </div>
                </div>
                {/* {!isProceed && (
                  <Button
                    disabled={purposeCode === ""}
                    onClickHandler={() => {
                      getDocuments();
                      if (noDocs) {
                        navigate("/pick-recipient");
                      }
                    }}
                    className="px-16 py-4 mt-8 font-semibold text-white transition-all rounded purpose-code-proceed bg-primary-1050 hover:scale-105"
                  >
                    Proceed
                  </Button>
                )} */}
              </>
            )}
            <div className="flex flex-wrap justify-center my-10 px-10">
              {listOfDocuments &&
                listOfDocuments.map((item: any) => {
                  return (
                    <>
                      <AdditionalDocumentsList
                        data={item}
                        setIsModalOpen={setIsModalOpen}
                        handleUploadAdditionalDocs={handleAdditionalDocUpload}
                        selectedPurposeValue={selectedPurposeValue}
                        handleAdditionalDocRemove={handleAdditionalDocRemove}
                        setPreViewImageSrc={setPreViewImage}
                        index={item.id}
                        buttonLoader={customLoader}
                        key={Math.random()}
                      />
                    </>
                  );
                })}
              <div>
                {listOfDocuments &&
                  (purposeValue === "Personal Gift or Donation" ||
                    purposeValue === "Family Maintenance") && (
                    <p className="bg-gray-100 p-2 rounded-sm">
                      <span className="font-semibold">Beneficiary ID</span> - user can upload any
                      identity document of the recipient. Ex - Passport, foreign driving license,
                      etc
                    </p>
                  )}
                {listOfDocuments && purposeValue === "Family Maintenance" && (
                  <p className="bg-gray-100 p-2 rounded-sm">
                    <span className="font-semibold">Relationship proof</span> - user can upload any
                    government issued document that shows the relationship with the beneficiary. Ex-
                    Passport, Marriage certificate etc.
                  </p>
                )}
              </div>
            </div>
            {isProceed && (
              <Button
                onClickHandler={handleProceed}
                className="px-16 py-4 mt-8 font-semibold text-white transition-all rounded purpose-code-proceed bg-primary-1050 hover:scale-105"
              >
                Submit
              </Button>
            )}
          </div>
          {/* <div className="border-2 border-gray-300 h-[650px] mt-12"></div>
          <div id="right" className="w-1/2 mt-10">
            <Calculation taxStep={taxStep} setTaxStep={setTaxStep} />
          </div> */}
        </div>
      </div>
      <Modals
        isModalOpen={isModalOpen}
        purposeCode={purposeCode}
        setIsModalOpen={setIsModalOpen}
        setPurposeCode={setPurposeCode}
        setPurposeValue={setPurposeValue}
        preViewModalHeader={preViewModalHeader}
        preViewImageSrc={preViewImage}
      />
    </div>
  );
};
